<template>
  <b-card v-if="caseParams.hasTicket && item.idTicket">
    <b-row>
      <b-col>
        <b-row align-h="between">
          <b-col cols="8"><b class="h6">{{$t('views.ticket.show.title')}}: </b> {{ item.idTicket.application.subdomain }}.{{ item.idTicket.application.domain.domain }}</b-col>
          <b-col cols="4" class="text-right">{{ $moment(item.idTicket.createdAt).format('YYYY-MM-DD HH:mm') }}</b-col>
        </b-row>
        <p class="mt-1"><b>{{$t('views.ticket.list.table.title')}}:</b> {{ item.idTicket.title }}</p>
        <p><b>{{$t('views.ticket.list.table.description')}}:</b> {{ item.idTicket.message }}</p>
        <p v-if="item.idTicket.userEmailFromApplication"><b>{{$t('views.ticket.list.table.userEmailFromApplication')}}:</b><a :href="'mailto: ' + item.idTicket.userEmailFromApplication"> {{ item.idTicket.userEmailFromApplication }}</a></p>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: 'CaseTicket',
  props: {
    item: {
      type: Object,
      required: true
    },
    caseParams: {
      required: true
    }
  }
}
</script>

<style scoped>

</style>
